import { IConnectedApplicationType } from '../serverApi/types/ConnectedApplicationType';
import { IConnectedApplicationInfo } from './ConnectedApplicationInfo';

// maps from the wire "Type" to the internal "Info" representation
// this would be straighforward except we are mapping "clientId" to "id"
// because there is code that likes "id"
export module ConnectedApplicationInfoMapper {

  export function map(
    rows: IConnectedApplicationType[]
  ): IConnectedApplicationInfo[] {
    return rows.map((m: IConnectedApplicationType) => {
      let domainSafelist = m.domainSafelist?.replace(/\s/g, '\n');

      return {
        contentType: 'connectedApplication',
        createdAt: m.createdAt,
        domainSafelist: domainSafelist,
        enabled: m.enabled,
        id: m.clientId,
        name: m.name,
        projectId: m.projectId,
        unrestrictedEmbedding: m.unrestrictedEmbedding,
        domainSafelistForDisplay: convertDomainSafelistToDisplay(domainSafelist, m.unrestrictedEmbedding)
      };
    });
  }

  export function convertDomainSafelistToDisplay(domainSafelist: string, unrestrictedEmbedding: boolean) {
    if (unrestrictedEmbedding) {
      // setting domain to undefined is equivalent to "All Domains"
      return undefined;
    }
    return (domainSafelist === undefined) ?
      '' : // setting domain to empty is equivalent to "None Domains"
      domainSafelist;
  }
}